import { Typography } from "@mui/material";
import React from "react";
import packageJson from '../../package.json';

const { version } = packageJson;

const Copyright = (props) => {
  const { isShowOwner } = props;
  return (
    <Typography {...props}>
      <div>{"Copyright © 2023 "}</div>
      <div className={isShowOwner ? "" : "d-none"}>
        {" "}
        ฝ่ายพัฒนานิสิต คณะวิศวกรรมศาตร์ มหาวิทยาลัยบูรพา
      </div>
      <div>{`Version ${version}`}</div>
    </Typography>
  );
};

export default Copyright;
